module.exports = __webpack_public_path__ + "static/img/de.4e64ea42.svg";